<template>
    <vue-draggable-resizable
        :w="size.width" :h="size.height" :x="axis.x" :y="axis.y" :z-index="9"
        @dragging="onDrag" @resizing="onResize" @dragstop="update" @resizestop="update" @deactivated="update">

            <div v-if="value.type === 'text-employer'" class="field-input-wrap">
                <v-text-field v-model="content" outlined placeholder="텍스트를 입력해주세요." class="v-input--small">
                    <template #append>
                        <v-btn text icon small color="grey" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                    </template>
                </v-text-field>               
            </div>

            <div v-if="value.type === 'text-employee'" class="field-input-wrap">
                <v-text-field v-model="content" readonly outlined placeholder="근로자가 입력할 텍스트입니다." class="v-input--small">                            
                    <template #append>
                        <v-btn text icon small color="grey" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                    </template>
                </v-text-field> 
            </div>

            <div v-if="value.type === 'check'" class="field-input-wrap">
                <div class="checkbox-wrap">
                    <v-checkbox v-model="content" hide-details="" readonly>
                        <template #append>
                            <v-btn text icon small color="grey" @click="()=>{ $emit('close', value)}"> <v-icon color="grey">mdi-close</v-icon> </v-btn>
                        </template>
                    </v-checkbox>
                </div>  
            </div>

            <div v-if="value.type === 'file'" class="field-input-wrap">
                <v-file-input v-model="content" disabled outlined class="v-input--small">
                    <template #append>
                        <v-btn text icon small color="grey" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                    </template>
                </v-file-input>
            </div>

            <div v-if="value.type === 'canvas'" class="field-input-wrap">
                <canvas></canvas>
                <v-btn absolute top right text icon small color="grey" style="top: 0; right: 0;" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
            </div>
            
    </vue-draggable-resizable>
    <!-- <vue-draggable-resizable
        :w="size.width" :h="size.height" :x="axis.x" :y="axis.y" :z-index="9"
        @dragging="onDrag" @resizing="onResize" @dragstop="update" @resizestop="update" @deactivated="update">
            <div v-if="value.type === 'text-employer'">
                <v-btn small text fab tile absolute right color="black" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                <v-text-field v-model="content" placeholder="텍스트를 입력해주세요" />
            </div>
            <div v-if="value.type === 'text-employee'">
                <v-btn small text fab tile absolute right color="black" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                <v-text-field v-model="content" placeholder="근로자가 입력할 텍스트입니다." disabled />
            </div>
            <div v-if="value.type === 'check'">
                <v-btn small text fab tile absolute right color="black" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                <v-checkbox v-model="content" disabled/>
            </div>
            <div v-if="value.type === 'file'">
                <v-btn small text fab tile absolute right color="black" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                <v-file-input v-model="content" disabled/>
            </div>
            <div v-if="value.type === 'canvas'">
                <v-btn small text fab tile absolute right color="black" @click="()=>{ $emit('close', value)}"> <v-icon>mdi-close</v-icon> </v-btn>
                <canvas></canvas>
            </div>
    </vue-draggable-resizable> -->
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
    components:{
        VueDraggableResizable
    },
    props:{
        value: { type: Object, default: ()=>({})},
        page: { type: Number, default: 0 }
    },
    data(){
        return{
            axis: {
                x: this.value?.axis?.x || 0,
                y: this.value?.axis?.y || 0,
            },
            size: {
                width: this.value?.size?.w || 100,
                height: this.value?.size?.h || 50,
            },
            content: this.value?.content || null
        }
    },
    methods:{
        onResize(x, y, width, height){
            this.axis.x = x;
            this.axis.y = y;
            this.size.width = width;
            this.size.height = height;
        },
        onDrag(x, y) {
            this.axis.x = x;
            this.axis.y = y;
        },
        update(){
            //emit to employment-form-form
            this.$emit('update',{
                ...this.value,
                content: this.content,
                axis:{ x: this.axis.x, y: this.axis.y},
                size:{ w: this.size.width, h: this.size.height},
            });
        }
    },
    watch:{
        content(){
            this.update();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>